export default __webpack_public_path__ + "resources/icons/d331-3a12.png";